import pay_ico_bank_AMEX from "../../images/pay/pay_ico_bank_AMEX.png";
import pay_ico_bank_DINERS from "../../images/pay/pay_ico_bank_DINERS.png";
import pay_ico_bank_DISCOVER from "../../images/pay/pay_ico_bank_DISCOVER.png";
import pay_ico_bank_JCB from "../../images/pay/pay_ico_bank_JCB.png";
import pay_ico_bank_MC from "../../images/pay/pay_ico_bank_MC.png";
import pay_ico_bank_UNIONPAY from "../../images/pay/pay_ico_bank_UNIONPAY.png";
import pay_ico_bank_VISA from "../../images/pay/pay_ico_bank_VISA.png";
export const payIcon = [pay_ico_bank_AMEX, pay_ico_bank_DINERS, pay_ico_bank_DISCOVER, pay_ico_bank_JCB, pay_ico_bank_MC, pay_ico_bank_UNIONPAY, pay_ico_bank_VISA];
